/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tournament_Error_LoadInputs */



/**
* | output |
* | --- |
* | "Failed to load tournament" |
*
* @param {Tournament_Error_LoadInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const tournament_error_load = /** @type {((inputs?: Tournament_Error_LoadInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tournament_Error_LoadInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Échec du chargement du tournoi")
	if (locale === "es") return /** @type {LocalizedString} */ ("Error al cargar torneo")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Falha ao carregar torneio")
	if (locale === "it") return /** @type {LocalizedString} */ ("Caricamento torneo fallito")
	return /** @type {LocalizedString} */ ("Failed to load tournament")
});